import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { ToggleButtonWithYesNo } from "../../AllButton/ToggleButtonReuse";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../navigationSection/BottomNavigationMobile";

import { Button, Image } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  update_new_subscription_for_vendor,
  // get_new_subscription_for_vendor,
} from "../../../../../../store/actions/authAction";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import MassCompletion from "../../../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MassCompletion";

export const EditFastFoodOrdering = (props) => {
  const history = useHistory();
  const [state, setState] = useState({
    casualFineDiningTakeAway: false,
    casualFineDiningCurbsideDelivery: false,
    casualFineDiningDineIn: false,
    casualFineDiningSkipTheLine: false,
    casualFineDiningAtMySeatTable: false,
    casualFineDiningCateringAndBanquet: false,
    casualFineDiningHomeDelivery: false,
    casualFineDiningBankAccounts: false,
    casualFineDiningGeneralSettings: false,
    massCompletion: false,
    massCompletionTime: "",
  });

  const onClickTakeAwayService = (e) => {
    if (state.casualFineDiningTakeAway === true && !e) {
      setState({
        ...state,
        casualFineDiningTakeAway: !state.casualFineDiningTakeAway,
      });
    } else {
      history.push({
        pathname: "/edit-ordering-fastfood-subscription/takeaway",
        state: e,
      });
    }
  };

  const onClickCurbsideDeliveryService = (e) => {
    if (state.casualFineDiningCurbsideDelivery === true && !e) {
      setState({
        ...state,
        casualFineDiningCurbsideDelivery:
          !state.casualFineDiningCurbsideDelivery,
      });
    } else {
      history.push({
        pathname: "/edit-ordering-fastfood-subscription/curbside",
        state: e,
      });
    }
  };

  const onClickDineInService = (e) => {
    if (state.casualFineDiningDineIn === true && !e) {
      setState({
        ...state,
        casualFineDiningDineIn: !state.casualFineDiningDineIn,
      });
    } else {
      history.push("/edit-ordering-fastfood-subscription/dinein");
    }
  };

  const onClickSkipTheLineService = (e) => {
    if (state.casualFineDiningSkipTheLine === true && !e) {
      setState({
        ...state,
        casualFineDiningSkipTheLine: !state.casualFineDiningSkipTheLine,
      });
    } else {
      history.push({
        pathname: "/edit-ordering-fastfood-subscription/skip-the-line",
        state: e,
      });
    }
  };

  const onClickCateringAndBanquetService = (e) => {
    if (state.casualFineDiningCateringAndBanquet === true && !e) {
      setState({
        ...state,
        casualFineDiningCateringAndBanquet:
          !state.casualFineDiningCateringAndBanquet,
      });
    } else {
      history.push({
        pathname: "/edit-ordering-fastfood-subscription/catering-banquet",
        state: e,
      });
    }
  };

  const onClickAtMySeatTableService = (e) => {
    if (state.casualFineDiningAtMySeatTable === true && !e) {
      setState({
        ...state,
        casualFineDiningAtMySeatTable: !state.casualFineDiningAtMySeatTable,
      });
    } else {
      history.push({
        pathname: "/edit-ordering-fastfood-subscription/atmyseat-tableorder",
        state: e,
      });
    }
  };

  const onClickHomeDeliveryService = (e) => {
    if (state.casualFineDiningHomeDelivery === true && !e) {
      setState({
        ...state,
        casualFineDiningHomeDelivery: !state.casualFineDiningHomeDelivery,
      });
    } else {
      history.push({
        pathname: "/edit-ordering-fastfood-subscription/homedelivery",
        state: e,
      });
    }
  };

  const onClickBankAccountsService = (e) => {
    if (state.casualFineDiningBankAccounts === true && !e) {
      setState({
        ...state,
        casualFineDiningBankAccounts: !state.casualFineDiningBankAccounts,
      });
    } else {
      history.push({
        pathname: "/edit-ordering-subscription/separate-bank-account",
        state: e,
      });
    }
  };

  const onClickGeneralSettingsService = (e) => {
    if (state.casualFineDiningGeneralSettings === true) {
      setState({
        ...state,
        casualFineDiningGeneralSettings: !state.casualFineDiningGeneralSettings,
      });
    } else {
      if (
        props.subscriptionData &&
        (props.subscriptionData.take_away.value ||
          props.subscriptionData.cubside_delivery.value ||
          props.subscriptionData.dine_in_order.value ||
          props.subscriptionData.self_serve.value ||
          props.subscriptionData.catering_banquet.value ||
          props.subscriptionData.my_seat_table_order.value)
      ) {
        history.push(
          "/edit-ordering-fastfood-subscription/order-general-taxes"
        );
      } else {
        alert(
          "Please add atleast one service in ordering. ex: take away, cubside delivery, dine in order, catering banquet, home delivery"
        );
      }
    }
  };

  // const onClickRedirectToOtherScreen = () => {
  //   let formData = {
  //     vendor_id: props?.auth?.user?.VendorUser?._id,
  //   };
  //   props.get_new_subscription_for_vendor(formData, onSuccessSubscription);
  // };

  // const onSuccessSubscription = () => {
  //   history.push({
  //     pathname: "/edit-ordering-subscription/order-general-taxes",
  //     state: { access: "edit" },
  //   });
  // };

  const massCompletionToggle = (e) => {
    setState({
      ...state,
      massCompletion: !state.massCompletion,
    });
  };

  const onChangeMassCompletion = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    setState({
      ...state,
      casualFineDiningTakeAway:
        (props?.subscriptionData &&
          props?.subscriptionData?.take_away?.value) ||
        false,
      casualFineDiningCurbsideDelivery:
        (props?.subscriptionData &&
          props?.subscriptionData?.cubside_delivery?.value) ||
        false,
      casualFineDiningDineIn:
        (props?.subscriptionData &&
          props?.subscriptionData?.dine_in_order?.value) ||
        false,
      casualFineDiningSkipTheLine:
        (props?.subscriptionData &&
          props?.subscriptionData?.self_serve?.value) ||
        false,
      casualFineDiningCateringAndBanquet:
        (props?.subscriptionData &&
          props?.subscriptionData?.catering_banquet?.value) ||
        false,
      casualFineDiningAtMySeatTable:
        (props?.subscriptionData &&
          props?.subscriptionData?.my_seat_table_order?.value) ||
        false,
      casualFineDiningHomeDelivery:
        (props?.subscriptionData &&
          props?.subscriptionData?.home_delivery?.value) ||
        false,
      casualFineDiningBankAccounts:
        (props?.subscriptionData &&
          props?.subscriptionData?.maintain_separate_bank?.value) ||
        false,
      casualFineDiningGeneralSettings:
        (props?.subscriptionData &&
          props?.subscriptionData?.order_general?.value) ||
        false,
      massCompletion:
        props?.subscriptionData?.massCompletion?.value !== null &&
        props?.subscriptionData?.massCompletion?.value !== undefined
          ? props?.subscriptionData?.massCompletion?.value
          : false,
      massCompletionTime:
        props?.subscriptionData?.massCompletion?.massCompletionTime !== null &&
        props?.subscriptionData?.massCompletion?.massCompletionTime !==
          undefined
          ? props?.subscriptionData?.massCompletion?.massCompletionTime
          : "",
    });
  }, [props.subscriptionData]);

  // const onclick = (value) => (e) => {
  //   setCasualFineDining({
  //     ...casualFineDining,
  //     casualFineDining: !value,
  //   });
  //   // console.log(e, value);
  // };

  // const onclick = (i) => (event) => {
  //   setCasualFineDining(() => {
  //     casualFineDining[i] = !casualFineDining[i];
  //   });
  // };

  const orderingClickSubmitHandler = (e) => {
    let valueData = {
      // value:
      //   state.casualFineDiningTakeAway ||
      //   state.casualFineDiningCurbsideDelivery ||
      //   state.casualFineDiningDineIn ||
      //   state.casualFineDiningSkipTheLine ||
      //   state.casualFineDiningAtMySeatTable ||
      //   state.casualFineDiningCateringAndBanquet ||
      //   state.casualFineDiningHomeDelivery ||
      //   state.casualFineDiningBankAccounts ||
      //   state.casualFineDiningGeneralSettings
      //     ? true
      //     : false,
      value: true,
      take_away: {
        value: state.casualFineDiningTakeAway,
      },
      cubside_delivery: {
        value: state.casualFineDiningCurbsideDelivery,
      },
      dineIn: {
        value: state.casualFineDiningDineIn,
      },
      self_serve: {
        value: state.casualFineDiningSkipTheLine,
      },
      catering_banquet: {
        value: state.casualFineDiningCateringAndBanquet,
      },
      my_seat_table_order: {
        value: state.casualFineDiningAtMySeatTable,
      },
      home_delivery: {
        value: state?.casualFineDiningHomeDelivery || false,
      },
      maintain_separate_bank: {
        value: state.casualFineDiningBankAccounts,
      },
      order_general: {
        value: state.casualFineDiningGeneralSettings,
      },
      massCompletion: {
        value: state.massCompletion,
        massCompletionTime: state.massCompletionTime,
      },
    };
    const token = props.auth.user.accessToken;
    const subscriptionId = props.subscription._id;
    let formData = props?.activeService
      ? props?.allSubscriptionsData?.multi_service_business_status
      : props?.allSubscriptionsData?.fast_food_dining_status;
    formData.ordering.value = valueData.value;
    formData.ordering.take_away.value = valueData.take_away.value;
    formData.ordering.cubside_delivery.value = valueData.cubside_delivery.value;
    if (props?.activeService) {
      formData.ordering.dine_in_order.value = valueData.dineIn.value;
    }
    formData.ordering.self_serve.value = valueData.self_serve.value;
    formData.ordering.catering_banquet.value = valueData.catering_banquet.value;
    formData.ordering.my_seat_table_order.value =
      valueData.my_seat_table_order.value;
    if (formData.ordering && formData.ordering.home_delivery)
      formData.ordering.home_delivery.value = valueData?.home_delivery?.value;
    formData.ordering.maintain_separate_bank.value =
      valueData.maintain_separate_bank.value;
    formData.ordering.order_general.value = valueData.order_general.value;
    formData.ordering.massCompletion.value = valueData?.massCompletion?.value;
    formData.ordering.massCompletion.massCompletionTime =
      valueData?.massCompletion?.massCompletionTime;
    // console.log(formData);
    props.update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Ordering subscription changes add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/profile");
  };
  const [disabled, setDisable] = useState(
    props &&
      props.history &&
      props.history.location &&
      props.history.location.state &&
      props.history.location.state.access === "view"
      ? true
      : false
  );

  const backButtonHandler = (e) => {
    e.preventDefault();
    history.push("/profile");
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>

          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation
              leftText="vendorReview"
              backButtonLink="/profile"
              displayText="Back"
            />
            <div className="col-12 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0  new-subscription-onboarding-component">
              <div className="">
                <div>
                  <TopTextReusableComponent
                    headingText={
                      props?.activeService
                        ? "Multi Service Business"
                        : "Fast Food, Cafe, Food Court and Other Order Setting"
                    }
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">Takeaway Service Enabled</div>
                    <div className="f10-400 opacity5">
                      (Takeaway service will be default activated)
                    </div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningTakeAway}
                      checkedBox={state.casualFineDiningTakeAway}
                      onChange={onClickTakeAwayService}
                      disabled={disabled}
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    {/* <Media query="(min-width: 991px)"> */}
                    {state.casualFineDiningTakeAway && (
                      <div className="d-flex ml-2">
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickTakeAwayService({ access: true })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickTakeAwayService({ access: false })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                      </div>
                    )}
                    {/* </Media> */}
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">Curbside Delivery Service</div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningCurbsideDelivery}
                      checkedBox={state.casualFineDiningCurbsideDelivery}
                      onChange={onClickCurbsideDeliveryService}
                      disabled={disabled}
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    {/* <Media query="(min-width: 991px)"> */}
                    {state.casualFineDiningCurbsideDelivery && (
                      <div className="d-flex ml-2">
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickCurbsideDeliveryService({ access: true })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickCurbsideDeliveryService({ access: false })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                      </div>
                    )}
                    {/* </Media> */}
                  </div>
                </div>
                {props?.activeService ? (
                  <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                    <div className="col-4 col-md-7 col-lg-6 p-0">
                      <div className="f14-700">Dine-In / Order Ahead</div>
                    </div>
                    <div className="col-4 col-md-4 col-lg-6">
                      <ToggleButtonWithYesNo
                        activeClass={state.casualFineDiningDineIn}
                        checkedBox={state.casualFineDiningDineIn}
                        onChange={onClickDineInService}
                        disabled={disabled}
                      />
                    </div>
                    <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                      {/* <Media query="(min-width: 991px)"> */}
                      {state.casualFineDiningDineIn && (
                        <div className="d-flex ml-2">
                          <>
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={() =>
                                onClickDineInService({ access: true })
                              }
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                                alt="View"
                                title="View"
                                fluid
                              />
                            </Button>
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={() =>
                                onClickDineInService({ access: false })
                              }
                            >
                              <Image
                                src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                                alt="Edit"
                                title="Edit"
                                fluid
                              />
                            </Button>
                          </>
                        </div>
                      )}
                      {/* </Media> */}
                    </div>
                  </div>
                ) : null}
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">
                      Self Serve / SkipTheLine / Order Ahead
                    </div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningSkipTheLine}
                      checkedBox={state.casualFineDiningSkipTheLine}
                      onChange={onClickSkipTheLineService}
                      disabled={disabled}
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    {/* <Media query="(min-width: 991px)"> */}
                    {state.casualFineDiningSkipTheLine && (
                      <div className="d-flex ml-2">
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickSkipTheLineService({ access: true })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickSkipTheLineService({ access: false })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                      </div>
                    )}
                    {/* </Media> */}
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">Home Delivery Order</div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningHomeDelivery}
                      checkedBox={state.casualFineDiningHomeDelivery}
                      onChange={onClickHomeDeliveryService}
                      disabled={disabled}
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    {state.casualFineDiningHomeDelivery && (
                      <div className="d-flex ml-2">
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickHomeDeliveryService({ access: true })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickHomeDeliveryService({ access: false })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">At My Seat or Table Order</div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningAtMySeatTable}
                      checkedBox={state.casualFineDiningAtMySeatTable}
                      onChange={onClickAtMySeatTableService}
                      disabled={disabled}
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    {/* <Media query="(min-width: 991px)"> */}
                    {state.casualFineDiningAtMySeatTable && (
                      <div className="d-flex ml-2">
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickAtMySeatTableService({ access: true })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickAtMySeatTableService({ access: false })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                      </div>
                    )}
                    {/* </Media> */}
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">Catering and Banquet Services</div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningCateringAndBanquet}
                      checkedBox={state.casualFineDiningCateringAndBanquet}
                      onChange={onClickCateringAndBanquetService}
                      disabled={disabled}
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    {/* <Media query="(min-width: 991px)"> */}
                    {state.casualFineDiningCateringAndBanquet && (
                      <div className="d-flex ml-2">
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickCateringAndBanquetService({ access: true })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickCateringAndBanquetService({
                                access: false,
                              })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                      </div>
                    )}
                    {/* </Media> */}
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">
                      Maintain Separate Bank Accounts For Payment & Disbursement
                      for Orders
                    </div>
                    <div className="d-flex align-items-center mt-2">
                      <div className="text-center" style={{ width: "8%" }}>
                        <i
                          className="fa fa-exclamation"
                          style={{
                            fontSize: "13px",
                            color: "#EF401B",
                            border: "1px solid #EF401B",
                            fontWeight: "lighter",
                            padding: "1px 5px",
                            borderRadius: "50%",
                          }}
                          aria-hidden="true"
                        ></i>
                      </div>
                      <div
                        className="f10-400 mobile-ml-2vh"
                        style={{ width: "92%", color: "#EF401B" }}
                      >
                        If you do not maintain bank account for now you will
                        need to maintain that later in session settings.
                      </div>
                    </div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningBankAccounts}
                      checkedBox={state.casualFineDiningBankAccounts}
                      onChange={onClickBankAccountsService}
                      disabled={disabled}
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    {/* <Media query="(min-width: 991px)"> */}
                    {state.casualFineDiningBankAccounts && (
                      <div className="d-flex ml-2">
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickBankAccountsService({ access: true })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              onClickBankAccountsService({ access: false })
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                      </div>
                    )}
                    {/* </Media> */}
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">Order General Settings Taxes*</div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningGeneralSettings}
                      checkedBox={state.casualFineDiningGeneralSettings}
                      onChange={onClickGeneralSettingsService}
                      disabled={
                        disabled ||
                        (props?.restaurantDetails?.pos?.restId &&
                          props?.restaurantDetails?.pos?.restId != "")
                      }
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    {/* <Media query="(min-width: 991px)"> */}
                    {props?.restaurantDetails?.pos?.restId &&
                    props?.restaurantDetails?.pos?.restId != ""
                      ? state.casualFineDiningGeneralSettings && (
                          <div className="d-flex ml-2">
                            <>
                              <Button
                                variant="link"
                                className="enIconBtn mr-3"
                                onClick={() =>
                                  onClickGeneralSettingsService({
                                    access: true,
                                  })
                                }
                              >
                                <Image
                                  src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                                  alt="View"
                                  title="View"
                                  fluid
                                />
                              </Button>
                              <Button
                                variant="link"
                                className="enIconBtn mr-3"
                                onClick={() =>
                                  onClickGeneralSettingsService({
                                    access: false,
                                  })
                                }
                              >
                                <Image
                                  src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                                  alt="Edit"
                                  title="Edit"
                                  fluid
                                />
                              </Button>
                            </>
                          </div>
                        )
                      : null}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <MassCompletion
                      MassCompletionToggle={(e) => massCompletionToggle()}
                      massCompletionValue={state.massCompletion}
                      handleChange={(e) => onChangeMassCompletion(e)}
                      massCompletionTime={state.massCompletionTime}
                    />
                  </div>
                </div>
                <br />
                <br />
                <div className="onboarding-map-setup-screen-autodetect-button pt-4">
                  <ReusableOnboardingButton
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    buttonType="button"
                    // onClick={(e) => history.push("/subscription")}
                    onClick={(e) => backButtonHandler(e)}
                  />
                  {!disabled && (
                    <ReusableOnboardingButton
                      buttonTitle="Done Button"
                      disabled={disabled}
                      buttonClass={
                        // state.casualFineDiningBankAccounts === true &&
                        state.casualFineDiningGeneralSettings === true
                          ? "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                          : "onboarding_button_link_reusable onboarding_button_link_reusable_white ml-3"
                      }
                      buttonText="Done"
                      buttonType="button"
                      onClick={
                        // state.casualFineDiningBankAccounts === true &&
                        state.casualFineDiningGeneralSettings === true
                          ? orderingClickSubmitHandler
                          : null
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

EditFastFoodOrdering.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription: state?.onboarding?.onboard_subscription_details,
  subscriptionData: state?.onboarding?.onboard_subscription_details
    ?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status?.ordering
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.ordering,
  allSubscriptionsData: state?.onboarding?.onboard_subscription_details,
  activeService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  restaurantDetails: state?.onboarding?.restaurantDetails,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  // get_new_subscription_for_vendor,
})(withRouter(EditFastFoodOrdering));
